export default __webpack_public_path__ + "locales/el-GR/People.json?hash=02576d4607fda26cbca617807a2e9116";